export class SingletonList {
    constructor() {
        this.elements = [];
        this.length = 0;
    }
    add(element) {
        let index = this.elements.indexOf(element);
        if (index != -1 && index < this.length)
            return;
        this.elements[this.length++] = element;
    }
    addList(list) {
        let len = this.length;
        let len2 = list.length;
        this.length = len + len2;
        let arr1 = this.elements;
        let arr2 = list.elements;
        if (arr1.length < this.length)
            arr1.length = this.length;
        for (let i = 0; i < len2; i++) {
            arr1[len + i] = arr2[i];
        }
    }
    indexof(element) {
        let index = this.elements.indexOf(element);
        if (index != -1 && index < this.length)
            return index;
        return -1;
    }
    remove(element) {
        let index = this.elements.indexOf(element);
        if (index != -1 && index < this.length) {
            this.elements[index] = this.elements[this.length - 1];
            this.elements[this.length - 1] = null;
            this.length--;
        }
    }
    clear() {
        this.elements.length = 0;
        this.length = 0;
    }
    clean() {
        this.elements.length = this.length;
    }
    cloneTo(out) {
        out.length = this.length;
        out.elements = this.elements.slice();
    }
    destroy() {
        this.elements = null;
    }
}
export class FastSinglelist extends SingletonList {
    add(element) {
        this.elements[this.length++] = element;
    }
}
